import {register} from '../vendor/theme-scripts/theme-sections';
import {slider} from '../features/slider';
import copyClipboard from '../features/copy-clipboard';
import slideToggle from '../util/slide-toggle';
import showElement from '../util/show-element';
import parallaxHero from '../features/parallax-hero';

const selectors = {
  sidebar: '.sidebar',
  widgetCategories: '.widget--categories',
  widgetLinksEl: '.widget__links',
  widgetLinks: '.widget__links .has-sub-nav > a',
  widgetLinksSub: '.widget__links .submenu > li > a',
  listEl: 'li',
  linkEl: 'a',
  articleSingle: '.article--single',
  sidebarContents: '.sidebar__contents',
  hasSubNav: '.has-sub-nav',
};

const classes = {
  classOpen: 'open',
  classActive: 'active',
  classSubmenu: 'submenu',
};

const sections = {};

class Article {
  constructor(section) {
    this.container = section.container;
    this.sidebar = this.container.querySelector(selectors.sidebar);
    this.widgetCategories = this.container.querySelector(selectors.widgetCategories);
    this.resizeEvent = () => this.categories();

    this.init();
  }

  init() {
    if (this.sidebar) {
      this.sidebarNav();
    }
  }

  sidebarNav() {
    this.navStates();

    // Dropdown Menus
    this.container.addEventListener('click', (e) => {
      const checkLinkTag = e.target.tagName.toLowerCase() === selectors.linkEl;
      const checkLinkParent = e.target.closest(`${selectors.listEl}${selectors.hasSubNav}`);
      const checkLinkClosest = e.target.closest(selectors.widgetLinksEl);
      const checkLink = checkLinkTag && checkLinkParent && checkLinkClosest;
      const submenu = e.target.nextElementSibling;
      const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      const isMobile = windowWidth < theme.sizes.small;

      if (!isMobile && checkLink && submenu) {
        submenu.parentElement.classList.toggle(classes.classActive);
        submenu.classList.toggle(classes.classOpen);
        submenu.setAttribute('aria-expanded', submenu.classList.contains(classes.classOpen));
        slideToggle(submenu);

        e.preventDefault();
      }
    });

    if (this.widgetCategories) {
      this.widgetCategoriesNext = this.widgetCategories.nextSibling;
      this.widgetCategoriesParentNode = this.widgetCategories.parentNode;

      this.categories();

      document.addEventListener('theme:resize', this.resizeEvent);
    }
  }

  navStates() {
    // Nav Active States
    const links = this.container.querySelectorAll(`${selectors.widgetLinks}, ${selectors.widgetLinksSub}`);

    if (links.length) {
      links.forEach((element) => {
        const href = element.getAttribute('href');
        const location = window.location.pathname;

        if (href === location) {
          const elementClosest = element.closest(selectors.hasSubNav);
          element.closest('li').classList.add(classes.classActive);
          if (!elementClosest) return;
          elementClosest.classList.add(classes.classActive);
          const submenu = elementClosest.querySelector(`.${classes.classSubmenu}`);

          if (submenu) {
            submenu.classList.toggle(classes.classOpen);
            submenu.setAttribute('aria-expanded', submenu.classList.contains(classes.classOpen));
            showElement(submenu);
          }
        }
      });
    }
  }

  categories() {
    const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const isMobile = windowWidth < theme.sizes.small;
    const widgetCategories = document.querySelector(selectors.widgetCategories);
    if (isMobile) {
      document.querySelector(selectors.articleSingle).prepend(widgetCategories);
    } else {
      this.widgetCategoriesParentNode.insertBefore(widgetCategories, this.widgetCategoriesNext);
    }
  }

  onUnload() {
    if (this.widgetCategories) {
      document.removeEventListener('theme:resize', this.resizeEvent);
    }
  }
}

const articleSection = {
  onLoad() {
    sections[this.id] = new Article(this);
  },
  onUnload(e) {
    sections[this.id].onUnload(e);
  },
};

register('article', [articleSection, slider, copyClipboard, parallaxHero]);
